import "./zone-view.scss";

import AbstractZoneView from "./abstract-zone-view";

class ZoneView extends AbstractZoneView {
	public static readonly tagName = "wf-debug-zone-view";
}
export default ZoneView;
